import { render, staticRenderFns } from "./PasswordConfirmModal.vue?vue&type=template&id=053a132c"
import script from "./PasswordConfirmModal.vue?vue&type=script&lang=js"
export * from "./PasswordConfirmModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports